import { SearchHeader } from '@components/search/SearchHeader';
import { SearchInput } from '@components/search/SearchInput';
import { SearchFeed } from '@components/search/SearchFeed';
import React from 'react';
import { SearchFeedProps } from '@components/search/SearchFeed/SearchFeed.types';

interface SearchProps<TData extends { id: string }> extends SearchFeedProps<TData> {
  inputTitle: string;
  headerTitle: string;
}

export function Search<TData extends { id: string }>({
  inputTitle,
  headerTitle,
  ...searchFeedProps
}: SearchProps<TData>) {
  return (
    <>
      <SearchHeader title={headerTitle} />
      <SearchInput title={inputTitle} />
      <SearchFeed {...searchFeedProps} />
    </>
  );
}
